module.exports = __webpack_public_path__ + "img/foward.eb322317.png";